export default __webpack_public_path__ + "static/media/sample-probono4.59ee47b9.png";